
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppTableHeaderRow extends Vue {
    @Prop() private headers!: string[]
}
